import BaseAutoGrid from "../../sisu/layout/BaseAutoGrid.sisu";

const NeoAutoGrid = (props) => {
    return (
        <BaseAutoGrid custom="SDAutoGrid" {...props}>{props.children}</BaseAutoGrid>
        )
}

export default NeoAutoGrid;